import { render, staticRenderFns } from "./AppSide.vue?vue&type=template&id=a864cc12&"
import script from "./AppSide.vue?vue&type=script&lang=js&"
export * from "./AppSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports